import {cUtil}  from './../../../functions/util';

export class cProductItemDeliveryInfo {

  fieldset_deliveryInfo     = document.createElement('fieldset');
  span_prepTimeLabel         = document.createElement('span');
  span_prepTimeValue         = document.createElement('span');
  span_countdownLabel        = document.createElement('span');
  span_countdownValue        = document.createElement('span');

  intervalHandler : number|undefined;
  intervalCleared : boolean|undefined;

  validDates      : string[];

  constructor(
    product : ProductData,
    parent  : HTMLElement, 
  ) {

    // --- Structure ---
    parent.append(this.fieldset_deliveryInfo);
      this.fieldset_deliveryInfo.append(this.span_prepTimeLabel);
      this.fieldset_deliveryInfo.append(this.span_prepTimeValue);
      this.fieldset_deliveryInfo.append(this.span_countdownLabel);
      this.fieldset_deliveryInfo.append(this.span_countdownValue);

    // --- Other ---
    this.fieldset_deliveryInfo.classList.add('fieldset_deliveryInfo');
    this.span_prepTimeLabel  .classList.add('span_prepTimeLabel');
    this.span_prepTimeValue  .classList.add('span_prepTimeValue');
    this.span_countdownLabel .classList.add('span_countdownLabel');
    this.span_countdownValue .classList.add('span_countdownValue');

    
    // ---- Init ----
    this.validDates = product.deliveryDates.validDates
    this.change(product);

  }

  change(product: ProductData) {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    const isNoneOrOneDay = 
      product.deliveryDates.deliveryTimeDesc === '' ||
      product.deliveryDates.deliveryTimeDesc.substring(0,1) === '1';

    if (isNoneOrOneDay ) {
      this.fieldset_deliveryInfo.style.display = 'none';
      return;
    }

    // this.span_prepTimeLabel.textContent = __('Vorbereitungszeit:', 'custom');
    this.span_prepTimeValue.textContent =   
      product.deliveryDates.deliveryTimeDesc !== '' 
      ? product.deliveryDates.deliveryTimeDesc 
      : __('1 Tag', 'custom');

    // const hasTime  = product.deliveryDates.cutOffHour !== 0;
    // const limmited = product.deliveryDates.deliveryTimeDesc.includes('11:00');

    // const orderDateLabel = 
    //   cUtil.customerPickUp()
    //   ? __('Abholung für den nächsten Tag:', 'custom')
    //   : __('Lieferung für den nächsten Tag:', 'custom');

    // if (!hasTime && limmited) {
    //   this.span_countdownLabel.textContent = orderDateLabel ; 
    //   this.span_countdownValue.textContent = __('Nicht möglich', 'custom');
    //   return;
    // }
    // else if (!hasTime) {
    //   return;
    // }
    // else {
    //   this.span_countdownLabel.textContent = orderDateLabel;  
    //   this.countDownStart(product.deliveryDates.cutOffHour, false);   
    // }
  }

  // countDownStop() {
  //   clearInterval(this.intervalHandler);
  //   this.intervalCleared = true;
  //   this.distance(15, true);
  // }

  countDownStart(hour: number, softDeadline: boolean) {
    this.intervalCleared = false;
    this.distance(hour, softDeadline);
    this.intervalHandler = setInterval(() => this.distance(hour, softDeadline), 1000 * 60);
  }

  distance(hour: number, softDeadline: boolean) {
    let countDownDate = new Date();
    countDownDate.setHours(hour);
    countDownDate.setMinutes(0);
    countDownDate.setSeconds(0);

    let now      = (new Date()).getTime();
    let target   = countDownDate.getTime();
    let distance = target - now;

    if (distance < 0) distance = distance + (1000 * 60 * 60 * 24);

    let hours    = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes  = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let value    = `${hours}h ${minutes}m`;
    
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    if (this.intervalCleared) {
      this.span_countdownValue.textContent = '';
    } 
    else if (distance < 0 && softDeadline) {
      clearInterval(this.intervalHandler);
      this.span_countdownValue.textContent = __('Lieferung unsicher', 'custom');
    }
    else if (distance < 0 && !softDeadline) {
      clearInterval(this.intervalHandler);
      this.span_countdownValue.textContent = __('Nicht mehr möglich', 'custom');
    }
    else {
      this.span_countdownValue.textContent = __('Noch', 'custom') + ` ${value}`
    }
  }
}
